import React from 'react';
import { useSelector } from 'react-redux';

const Dashboard = () => {
  const { role } = useSelector(state => state.auth);

  return (
    <div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '1.5rem' }}>
        
        <div className="stat-card">
          <div className="stat-icon" style={{ background: '#eef2ff', color: '#4f46e5' }}>👥</div>
          <div>
            <div style={{ fontSize: '1.75rem', fontWeight: 'bold' }}>13</div>
            <div style={{ fontSize: '0.875rem', color: 'var(--text-secondary)' }}>Total members</div>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon" style={{ background: '#ecfdf5', color: '#10b981' }}>💳</div>
          <div>
            <div style={{ fontSize: '1.75rem', fontWeight: 'bold' }}>9</div>
            <div style={{ fontSize: '0.875rem', color: 'var(--text-secondary)' }}>Active subscriptions</div>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon" style={{ background: '#ecfdf5', color: '#10b981' }}>✓</div>
          <div>
            <div style={{ fontSize: '1.75rem', fontWeight: 'bold' }}>2</div>
            <div style={{ fontSize: '0.875rem', color: 'var(--text-secondary)' }}>Total Completed</div>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon" style={{ background: '#fffbeb', color: '#f59e0b' }}>📅</div>
          <div>
            <div style={{ fontSize: '1.75rem', fontWeight: 'bold' }}>131</div>
            <div style={{ fontSize: '0.875rem', color: 'var(--text-secondary)' }}>Total Upcoming</div>
          </div>
        </div>
        
      </div>
    </div>
  );
};

export default Dashboard;
